import Vue from "vue";
import Router from "vue-router";

import AdminPannel from "@/components/AdminPannel.vue";
import Booking from "@/components/Booking.vue";
import CancelApp from "@/components/CancelApp.vue";
import CancelPAuto from "@/components/CancelPAuto.vue";
import Change from "@/components/Change.vue";
import EventBooking from "@/components/EventBooking.vue";
import ForkBooking from "@/components/ForkBooking.vue";
import Login from "@/components/Login.vue";
import Permanence from "@/components/Permanence.vue";
import Reload from "@/components/Reload.vue";
// page component
import Restaurant from "@/components/Restaurant.vue";
import Success from "@/components/Success.vue";
import SuccessApp from "@/components/SuccessApp.vue";
import SuccessPAuto from "@/components/SuccessPAuto.vue";
import Redirect from "../components/Redirect.vue";

Vue.use(Router);

// define all routes and basic rules
const router = new Router({
	mode: "history",
	routes: [
		{
			path: "*",
			redirect: "Login",
		},
		{
			path: "/",
			redirect: "Login",
		},
		{
			path: "/restaurant",
			name: "Restaurant",
			component: Restaurant,
			meta: {
				requiresAuth: true,
			},
			props: true,
		},
		{
			path: "/change/:id/:ts/:resa",
			name: "change",
			component: Change,
			props: true,
		},
		{
			path: "/success/:crid/:id",
			name: "success",
			component: Success,
			props: true,
		},
		{
			path: "/successapp/:crid/:id",
			name: "successapp",
			component: SuccessApp,
			props: true,
		},
		{
			path: "/cancelpauto/:crid/:id",
			name: "cancelpauto",
			component: CancelPAuto,
			props: true,
		},
		{
			path: "/successpauto/:crid/:id",
			name: "successpauto",
			component: SuccessPAuto,
			props: true,
		},
		{
			path: "/cancelapp/:crid/:id",
			name: "cancelapp",
			component: CancelApp,
			props: true,
		},
		{
			path: "/permanence",
			name: "Permanence",
			component: Permanence,
			meta: {
				requiresAuth: true,
			},
			props: true,
		},
		{
			path: "/permanence/:id",
			name: "PRedirect",
			component: Restaurant,
			meta: {
				requiresAuth: true,
			},
			props: true,
		},
		// event booking
		{
			path: "/event/:id/:eventid",
			name: "event",
			component: EventBooking,
			props: true,
		},
		{
			path: "/event-new/:id/:eventid",
			name: "event",
			meta: { isIframe: false },
			component: ForkBooking,
			props: true,
		},
		// booking
		{
			path: "/booking/web/:id",
			name: "site web",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/web/:id",
			name: "site web",
			component: ForkBooking,
			meta: { isIframe: false, bookingNew: true },
			props: true,
		},
		{
			path: "/booking-iframe/web/:id",
			name: "site web",
			meta: { isIframe: true, bookingNew: true },
			component: ForkBooking,
			props: true,
		},
		// social network booking
		{
			path: "/booking/influencer/:id",
			name: "influencer",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/influencer/:id",
			name: "influencer",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},

		{
			path: "/booking/facebook/:id",
			name: "facebook",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/facebook/:id",
			name: "facebook",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		{
			path: "/booking/google/:id",
			name: "google",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/google/:id",
			name: "google",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		{
			path: "/booking/yelp/:id",
			name: "yelp",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/yelp/:id",
			name: "yelp",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		{
			path: "/booking/tripadvisor/:id",
			name: "tripadvisor",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/tripadvisor/:id",
			name: "tripadvisor",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		{
			path: "/booking/instagram/:id",
			name: "instagram",
			component: Booking,
			props: true,
		},
		{
			path: "/booking-new/instagram/:id",
			name: "instagram",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		// other booking
		{
			path: "/booking/lyonresto/:id",
			name: "lyonresto",
			component: Booking,
			props: true,
		},
		{
			path: "/booking/permanance/:id",
			name: "permanance",
			component: Booking,
			props: true,
		},
		// google e2e
		{
			path: "/google/external/:id",
			name: "google-external",
			component: ForkBooking,
			meta: {
				bookingNew: true,
			},
			props: true,
		},
		// others
		{
			path: "/r/:shortcode",
			name: "redirect",
			component: Redirect,
		},
		{
			path: "/login",
			name: "Login",
			component: Login,
		},
		{
			path: "/reload",
			name: "Reload",
			component: Reload,
		},
		{
			path: "/admin",
			name: "Admin",
			component: AdminPannel,
			meta: {
				requiresAuth: true,
			},
		},
	],
});

/**
 * before Each route calls
 */
router.beforeEach((to, from, next) => {
	if (to.name !== "site web") {
		// get current user
		let currentUser = localStorage.getItem("uResaNinja");
		// get cookie if no local user exist
		let decodedCookie = getCookie("uResaNinja");
		if (!currentUser && decodedCookie !== "") {
			currentUser = decodedCookie;
		}
		// get if route require an authentification to be displayed
		let requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
		// noUser logged && requireAuth -> login
		if (requiresAuth && !currentUser) next("login");
		// user logged trying to login -> restaurant
		else if (to.name === "Login" && currentUser) next("restaurant");
		else next();
	}
	next();
});

function getCookie(cname) {
	let name = `${cname}=`;
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export default router;
